// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar[data-v-61d03b74]{background:#171725}.dashboard-background-color[data-v-61d03b74]{background:#f7f7f7}.logout-btn[data-v-61d03b74]{border-color:red}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
